<template>
  <div>
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <div class="mt-5 ">
        <div class="titleSectionv2 d-flex mb-4">
          <div style="margin-right: -15px;margin-left: -10px">
            <img src="../../assets/image/user-journey/c0c755c4a2f783163a75b8189b5810ab45c7652e.gif"
                 width="50px" alt="">
          </div>
          <div>
            چه زمانی رو برای جلسه تراپی ترجیح می‌دی؟
          </div>
          <v-spacer></v-spacer>
          <div class=" " style="position: relative">
            <div class="d-flex">

            </div>
            <v-fade-transition>
              <div class="timeZoneMenu" key="10" v-if="menuTimezoneIsOpen">
                <div class="searchBoxArea">
                  <v-text-field @input="searchTimezone" dense v-model="timezoneParams" outlined
                                color="black"
                                label="  جستجو...">

                  </v-text-field>
                </div>
                <div class="timezoneList">
                  <div class="timeZoneItem" v-for="(item , i) in timezoneResultList" :key="i"
                       @click="updateTz(item.value)">
                    <div class="d-flex">
                      <div class="timezoneLine"
                           :style="item.value == profile.tz && 'background-color:#EAF0F6'">

                      </div>
                      <div class="timezoneImage">
                        <img src="../../assets/image/user-journey/world.svg" alt="">
                      </div>
                      <div class="timezoneName">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-fade-transition>
          </div>
        </div>
        <template>
          <div class="timeItem "  @click="timeSelector = 'first_time'"
               :class="timeSelector == 'first_time' && 'timeItemActive'">
            <div class="titleItem">
              اولین نوبت آزاد:
            </div>
            <div class="detailItem mt-2">
              <div>
                <v-radio-group class="pa-0 " style="margin-bottom: -50px;margin-top: -0px"
                               v-model="timeSelector">
                  <v-radio value="first_time" dense></v-radio>
                </v-radio-group>
              </div>
              <div>
                {{ firstTime.from_time | jalaliDateTime }}
                {{ firstTime | getDayPeriodsLabel }}
                <!--                            یکشنبه 2025/02/24 - ساعت 15:00 عصر-->
              </div>
            </div>
          </div>
          <div class="timeItem mt-2" @click="changeTimeSelector('select_time')"
               :class="timeSelector == 'select_time' && 'timeItemActive'">
            <div class="detailItem mt-2">
              <div>
                <v-radio-group class="pa-0 " style="margin-bottom: -50px;margin-top: -0px"
                               v-model="timeSelector">
                  <v-radio value="select_time" dense></v-radio>
                </v-radio-group>
              </div>
              <div>
                مشاهده تقویم و انتخاب زمان های دیگر
              </div>
            </div>
          </div>
        </template>
        <v-fade-transition>

          <div class="daysArea mt-5" v-if="timeSelector == 'select_time'">
            <div class="d-flex dayBoxList" v-if="times.length != 0">
              <div class="dayBox " v-for="(time,i) in times" :key="i"
                   @click="selectDay(time)"
                   :class="(selectedDay && selectedDay.id == time.id) ? 'activeDayBox' : ''">
                <div class="dayName">{{ time.date | weekDayName }}</div>
                <div class="dateName">
                  {{ time.date | dayNumber }}

                  {{ time.date | getShortMonth }}

                </div>
                <div class="sessionCount"
                     :class="time.periods.length == 1 ? 'red--text' : 'green--text'">
                  {{ time.periods.length }}
                  نوبت
                </div>
              </div>
            </div>
            <div>
            </div>
          </div>
        </v-fade-transition>
      </div>
      <v-fade-transition mode="out-in">
        <div class="selectedDay mb-10" v-if="timeSelector == 'select_time'">
          <div class="mt-2" v-if="selectedDay">
            <v-tabs
                v-model="tab"
                fixed-tabs
                class="pa-0 ma-0"
                color="#39C990"
            >
              <v-tab color="pa-0 ma-0" value="morning">صبح</v-tab>
              <v-tab color="pa-0 ma-0" value="evening">عصر</v-tab>
              <v-tab color="pa-0 ma-0" value="night">شب</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item :value="0">
                <div class="timesBox d-flex pa-5">
                  <div class="timeBlock"
                       :class="(selectedTime && selectedTime.id == time.id) ? 'activeTimeBlock': ''"
                       @click="selectTime(time)" v-for="(time,i) in selectedDay.morning"
                       :key="i">
                    {{ time.from_time | getTime }}
                    صبح
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item :value="1">
                <div class="timesBox d-flex pa-5">
                  <div class="timeBlock"
                       :class="(selectedTime && selectedTime.id == time.id) ? 'activeTimeBlock': ''"
                       @click="selectTime(time)" v-for="(time,i) in selectedDay.evening"
                       :key="i">
                    {{ time.from_time | getTime }}
                    عصر
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item :value="2">
                <div class="timesBox d-flex pa-5">
                  <div class="timeBlock"
                       :class="(selectedTime && selectedTime.id == time.id) ? 'activeTimeBlock': ''"
                       @click="selectTime(time)" v-for="(time,i) in selectedDay.night"
                       :key="i">
                    {{ time.from_time | getTime }}
                    شب
                  </div>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </v-fade-transition>
    </template>
    <template v-else>
      <div class="whiteBox">

      </div>
      <div class="whiteBox" style="margin-bottom: 50px">
        <div class=" d-flex">
          <div style="margin-right: -15px;margin-left: -15px" class="d-flex flex-column justify-center">
            <img src="../../assets/image/user-journey/c0c755c4a2f783163a75b8189b5810ab45c7652e.gif"
                 width="50px" alt="">
          </div>
          <div class="timezoneName">
            چه زمانی رو برای جلسه مشاوره ترجیح می‌دی؟
          </div>
        </div>
        <div class="mt-5">
          <template v-if="times.length != 0">
            <div class="timeItem" @click="timeSelector = 'first_time'"
                 :class="timeSelector == 'first_time' && 'timeItemActive'">
              <div class="titleItem">
                نزدیک‌ترین زمان برای گفت‌وگو:
              </div>
              <div class="detailItem mt-2">
                <div>
                  <v-radio-group class="pa-0 " style="margin-bottom: -50px;margin-top: -0px"
                                 v-model="timeSelector">
                    <v-radio value="first_time" dense></v-radio>
                  </v-radio-group>
                </div>
                <div>
                  {{ firstTime.from_time | jalaliDateTime }}
                  {{ firstTime | getDayPeriodsLabel }}
                  <!--                            یکشنبه 2025/02/24 - ساعت 15:00 عصر-->
                </div>
              </div>
            </div>
            <div class="timeItem mt-2" :class="timeSelector == 'select_time' && 'timeItemActive'">
              <div @click="changeTimeSelector('select_time')" class="detailItem mt-2">
                <div>
                  <v-radio-group class="pa-0 " style="margin-bottom: -50px;margin-top: -0px"
                                 v-model="timeSelector">
                    <v-radio value="select_time" dense></v-radio>
                  </v-radio-group>
                </div>
                <div>
                  مشاهده تقویم و انتخاب زمان های دیگر
                </div>
              </div>
            </div>
          </template>
          <v-fade-transition>
            <div class="daysArea mt-5" v-if="timeSelector == 'select_time'">
              <div class="d-flex dayBoxList ">
                <div class="dayBox " v-for="(time,i) in times" :key="i" @click="selectDay(time)"
                     :class="(selectedDay && selectedDay.id == time.id) ? 'activeDayBox' : ''">
                  <div class="dayName">{{ time.date | weekDayName }}</div>
                  <div class="dateName">
                    {{ time.date | dayNumber }}

                    {{ time.date | getShortMonth }}

                  </div>
                  <div class="sessionCount" :class="time.periods.length == 1 ? 'red--text' : 'green--text'">
                    {{ time.periods.length }}
                    نوبت
                  </div>
                </div>
              </div>
              <div>
              </div>
            </div>
          </v-fade-transition>

          <v-fade-transition mode="out-in">
            <div class="selectedDay mb-10" v-if="timeSelector == 'select_time'">
              <div class="mt-2" v-if="selectedDay">
                <v-tabs
                    v-model="tab"
                    fixed-tabs
                    class="pa-0 ma-0"
                    color="#39C990"
                >
                  <v-tab color="pa-0 ma-0" value="morning">صبح</v-tab>
                  <v-tab color="pa-0 ma-0" value="evening">عصر</v-tab>
                  <v-tab color="pa-0 ma-0" value="night">شب</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item :value="0">
                    <div class="timesBox">
                      <v-row class="pa-5">
                        <v-col cols="3" v-for="(time,i) in selectedDay.morning" class="px-1 py-1 ma-0" :key="i">
                          <div :class="(selectedTime && selectedTime.id == time.id) ? 'activeTimeBlock ': ''"
                               @click="selectTime(time)" class="timeBlock">
                            {{ time.from_time | getTime }}
                            صبح
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-tab-item>
                  <v-tab-item :value="1">
                    <div class="timesBox">
                      <v-row class="pa-5">
                        <v-col cols="3" v-for="(time,i) in selectedDay.evening" class="px-1 py-1 ma-0" :key="i">
                          <div :class="(selectedTime && selectedTime.id == time.id) ? 'activeTimeBlock ': ''"
                               @click="selectTime(time)" class="timeBlock">
                            {{ time.from_time | getTime }}
                            عصر
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-tab-item>
                  <v-tab-item :value="2">
                    <div class="timesBox">
                      <v-row class="pa-5">
                        <v-col cols="3" v-for="(time,i) in selectedDay.night" class="px-1 py-1 ma-0" :key="i">
                          <div :class="(selectedTime && selectedTime.id == time.id) ? 'activeTimeBlock ': ''"
                               @click="selectTime(time)" class="timeBlock">
                            {{ time.from_time | getTime }}
                            شب
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>
          </v-fade-transition>

        </div>

        <slot name="bottomCalendar">

        </slot>

      </div>
    </template>


    <v-bottom-sheet style="border-radius: 16px 16px 0px 0px " v-model="timezoneBottomSheet">
      <div class="white" style="border-radius: 16px 16px 0px 0px ">
        <div class="headerBottomSheet  pt-3">
          <div class="d-flex">
            <div class="flex-grow-1 mr-2 titleBottomSheet">
              تغیر محدود زمانی
            </div>
            <div @click="timezoneBottomSheet = false">
              <v-icon small>
                mdi-close
              </v-icon>
            </div>
          </div>
        </div>
        <div class="timezoneSearchArea bodyContext" style="height: 80%">
          <v-text-field
              v-model="timezoneParams"
              @input="searchTimezone"
              outlined color="black"
              placeholder="انتخاب محدوده زمانی"
              prepend-inner-icon="mdi-magnify"
          >
          </v-text-field>
          <div class="timezoneList" :style="`height: ${heightTimezoneBox}`">
            <div class="timezoneItem d-flex" v-for="(tz, i ) in timezoneResultList" :key="i"
                 @click="updateTz(tz.value)">
              <img src="../../assets/image/user-journey/world.svg" class="ml-2" width="20px" alt="">
              <div class="timezoneName py-2">
                {{ tz.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-bottom-sheet>


  </div>
</template>

<script>

import moment from 'moment-timezone';
// import momentJalali from "moment-jalaali";
import {mapGetters} from "vuex";
import momentJalali from "moment-jalaali";

export default {
  props: {
    firstTime: Object,
    times: Array,
    selectedTime: Object,
  },
  data() {
    return {
      menuTimezoneIsOpen: false,
      timezoneParams: null,
      timeSelector: 'first_time',
      selectedDay: null,
      tab: "morning",
      timezoneResultList: null,
      timezoneBottomSheet: false,
    }
  },
  computed: {
    ...mapGetters({
      'profile': 'getProfile'
    }),
    heightTimezoneBox() {
      return screen.height - 250 + "px"
    }
  },
  mounted() {
    // this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 3)

    this.user = JSON.parse(JSON.stringify(this.profile))

    let times = JSON.parse(JSON.stringify(this.timezones));
    this.timezonesList = times.map((item) => {
      item.text = item.text + '  ' + moment.tz(item.text).format('Z');
      return item;
    });

    this.timezoneResultList = this.timezonesList
  },
  methods: {
    changeTimeSelector(state) {
      this.timeSelector = state
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth' // optional: smooth scrolling
        });
      }, 100)
    },
    selectDay(day) {
      this.selectedDay = day
      if (this.selectedDay.morning.length != 0) {
        this.tab = 0
      } else if (this.selectedDay.evening.length != 0) {
        this.tab = 1
      } else {
        this.tab = 2
      }
    },
    updateTz(tz) {
      let payload = {
        timezone: tz,
      }
      this.menuTimezoneIsOpen = false
      this.timezoneBottomSheet = false
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'editProfile', '', payload).then(() => {
        this.selectedDay = null
        this.$emit('resetTimesBox')
        this.$emitEvent('notify', {color: 'green', title: 'موقعیت زمانی شما ویرایش شد', id: 'ga_login'});
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    searchTimezone() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        console.log(this.timezoneParams)
        this.timezoneResultList = this.timezonesList.filter(i =>
            (i.text || "").toLowerCase().includes((this.timezoneParams || "").toLowerCase())
        )

        console.log(this.timezoneResultList)
      }, 500)
    },
    selectTime(time) {
      this.$emit('selectTime', time)
    }
  },
  filters: {
    weekDayName(dateStr) {
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(dateStr).format("dddd");
    },
    getTime(dateStr) {
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(dateStr).format("HH:mm");
    },
    getShortMonth(dateStr) {
      return momentJalali(dateStr, "YYYY-MM-DD").locale('fa').format("jMMMM");
    },
    dayNumber(dateStr) {
      return momentJalali(dateStr, "YYYY-MM-DD").format("jDD");
    },
    getDayPeriodsLabel(time) {
      console.log(time.from_time)
      const hour = parseInt(momentJalali(time.from_time).format('HH'));
      console.log(hour, '1212')
      if (hour) {
        if (hour >= 0 && hour < 12) {
          return 'صبح'
        } else if (hour >= 12 && hour < 18) {
          return 'عصر'
        } else if (hour >= 18 && hour <= 23) {
          return 'شب'
        }
      }
    },
    jalaliDateTime(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd jYYYY/jMM/jDD - [ساعت] hh:mm');
    },
    jalaliDateTimePartOne(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/DD ');
    },
    jalaliDateTimePartTwo(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format(' [ساعت] hh:mm');
    },
    jalaliDateTimeWithoutLabel(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format('  hh:mm');
    },

  },

}
</script>

<style scoped>

@media (min-width: 200px) and (max-width: 1000px) {


  .bodyContext {
    padding-top: 16px !important;
  }

  .titleItem {
    font-size: 16px !important;
  }

  .detailItem {
    font-size: 16px !important;
  }

  .daysArea {
    overflow-y: scroll;
    width: 100% !important;
    padding: 0px 0px 10px 10px;
  }

  .dayBox {
    width: 84px !important;
  }

  .dayName {
    font-size: 16px !important;
  }

  .dateName {
    font-size: 14px !important;
  }

  .dayBoxList > * {
    flex: 0 0 80px !important;
  }

  .timeBlock {
    width: 100% !important;
    font-size: 11px !important;
    height: 40px !important;
    padding: 0px 8px !important;
    margin-left: 0px !important;
  }


}

.timeZoneMenu {
  position: absolute;
  top: 35px;
  left: 0px;
  width: 356px;
  border-radius: 8px;
  border: 1px solid #EEE;
  background: #FFF;
  z-index: 1;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip):not(.v-avatar), .v-card > .v-card__progress + *:not(.v-btn):not(.v-chip):not(.v-avatar) {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}


.dayBoxList > * {
  flex: 0 0 110px;
}


.timezoneList {
  overflow-y: auto;
  margin-top: -20px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.searchBoxArea {
  padding: 16px 16px 0px 16px;
}

.timeZoneItem {
  display: flex;
  border-bottom: 1px solid #F5F5F5;
  cursor: pointer;
}

.timeZoneItem > div {
  padding: 16px;
}

.timezoneLine {
  width: 5px;
  height: 50px;
  border-radius: 10px;
  transition: all 0.3s;
  cursor: pointer;
}

.timeZoneItem:hover .timezoneLine {
  background: #EAF0F6;
  transition: all 0.3s;
}

.timezoneImage {
  display: flex;
  flex-direction: column;
  padding: 16px 8px 0px 8px;
}

.timezoneName {
  padding: 16px 0px 0px 16px;
  margin-right: 8px;
  color: #424242;
  text-align: right;

  /* Body/Small/Medium14 */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
}

.timezoneSearchArea {
  padding: 16px 24px;
}

.headerBottomSheet {
  padding: 16px 24px;
  border-bottom: 1px solid #EAF0F6;
}


.titleBottomSheet {
  font-size: 18px;
  color: #212121;
  font-weight: 500;
}

.timezoneName {
  color: #424242;
  text-align: right;
  font-size: 16px;
  font-family: "YekanBakh", "Roboto" !important;
  font-weight: 500;
}

.actionTimezone {
  color: #035184;
  font-weight: 500;
  font-size: 16px;
}

.timezoneName {
  color: #424242;
  text-align: right;
  font-size: 16px;
  font-weight: 500;
}

.titleWhiteBox {
  color: #616161;
  font-size: 14px;
  font-weight: 500;
}

.whiteBox {
  margin-top: 8px;
  background: white;
  padding: 10px 24px;
}

.activeDayBox {
  border-radius: var(--Space-3, 8px);
  border-color: #39C990 !important;
  background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
  transition: all 0.3s;
}

.selectedDay {
  min-height: 150px;
}


.timeBlock {
  border-radius: var(--Space-3, 8px);
  border: 1px solid var(--Bluegray-bluegray-lighten-3, #DBE4ED);
  background: var(--shades-white, #FFF);
  height: 48px;
  padding: 0px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 8px;
  width: 130px;
  cursor: pointer;
  transition: all 0.3s;
}

.activeTimeBlock {
  border: 1px solid var(--Primary-Main, #39C990) !important;
  background: linear-gradient(180deg, #FFF 1.44%, #D7F4E9 100%) !important;
  color: #39C990;
  transition: all 0.3s;
}

.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #757575 !important;;
  font-weight: 700;

}

.dayBox {
  border-radius: var(--Space-3, 8px);
  border: 1px solid var(--Bluegray-bluegray-lighten-3, #DBE4ED);
  background: var(--shades-white, #FFF);
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  text-align: center;
  margin-left: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.dayBox:hover {
  background: #F6F9FC;
  transition: all 0.3s;
}

.dayName {
  color: var(--grey-grey-darken-2, #616161);
  text-align: center;
  /* Body/Large/Medium18 */
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.dateName {
  color: var(--grey-grey-darken-2, #616161);
  text-align: center;
  font-size: var(--Font-Size-lg, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}

.sessionCount {
  color: var(--Error-400, #FF5252);
  text-align: center;
  /* Body/Small/Medium14 */
  font-size: var(--Font-Size-md, 14px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 171.429% */
}


.confirmBtn {
  height: 50px !important;
  font-size: var(--Font-Size-Xl, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 8px;
}

.confirmBtnOutline {
  height: 50px !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 8px;
}


.footerContext {
  box-shadow: 0 -2px 4px 0 rgba(219, 228, 237, 0.40);
  padding: 16px 24px;
}


.detailItem {
  color: var(--grey-grey-darken-2, #616161);
  /* Body/Large/Medium18 */
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.timeItem {
  border-radius: var(--Space-3, 8px);
  border: 1px solid var(--Bluegray-bluegray-lighten-2, #EAF0F6);
  background: var(--shades-white, #FFF);
  padding: var(--Space-4, 12px) 16px;
  transition: all 0.3s;
}
.timeItemActive{
  border-color: rgba(57, 201, 144, 1);
}

.titleItem {
  color: var(--grey-grey-darken-3, #424242);
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}


.customInputGrey .v-text-field fieldset, .v-text-field .v-input__control {
  border-color: #DBE4ED !important;
  border-radius: 8px !important;
}

/* Ensure Roboto/YekanBakh font is used inside Vuetify text inputs within this component */
::v-deep .v-text-field input,
::v-deep .v-text-field .v-label,
::v-deep .v-text-field .v-input__control,
::v-deep .v-text-field .v-input__slot,
::v-deep .v-textarea textarea,
::v-deep .v-textarea .v-label {
  font-family: Roboto, YekanBakh !important;
}


.bodyContext {
  padding: 0px 24px 16px 24px;

}


.titleSectionv2 {
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}


.arrowBack img {
  width: 24px;
  margin: 0px auto;
}

</style>
